interface PrimaryButtonProps {
  onClick?: () => void;
  label: string;
  className?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  onClick,
  label,
  className,
}) => (
  <div className="pt-2">
    <button
      onClick={onClick}
      className={`w-full bg-[#FBD037] text-[#000000] font-semibold py-3 rounded-full ${className}`}
    >
      {label}
    </button>
  </div>
);

export default PrimaryButton;
